import { takeEvery, all, call, put, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import usuarioService from '../../../commons/services/usuario';
import { types, actions } from './actions';

function* getUsers({ payload }) {
	const currentLogged = yield select(state => state.usuario.identificacao);

	yield put(actions.handleLoading({ users: true }));

	yield call(delay, 750);

	try {
		const res = yield call(usuarioService.getUsersLinkedByCPNJ, {
			cnpj: currentLogged,
			page: payload
		});

		yield put(actions.getUser.receive(res));
	} catch (err) {
	} finally {
		yield put(actions.handleLoading({ users: false }));
	}
}

function* searchUser({ payload }) {
	yield put(actions.handleLoading({ search: true }));
	yield call(delay, 750);

	try {
		const data = yield call(usuarioService.searchCpf, payload);
		yield put(actions.searchUser.receive(data));
	} catch (err) {
		yield put(actions.searchUser.error(err.response.data.mensagem));
	} finally {
		yield put(actions.handleLoading({ search: false }));
	}
}

function* linkUser({ payload }) {
	const currentLogged = yield select(state => state.usuario.identificacao);

	const body = {
		id: payload.id,
		cpf: payload.cpf,
		nome: payload.nome,
		cnpjUsuarioLogado: currentLogged
	};

	try {
		yield call(usuarioService.registerUser, body);
		yield put(actions.linkUser.receive());
		const page = 0;
		yield put(actions.getUser.request(page));
	} catch (err) {
		yield put(actions.linkUser.error(err.response.data.message));
	}
}

function* removeUser({ payload }) {
	const currentLogged = yield select(state => state.usuario.identificacao);

	const body = {
		id: payload.id,
		cpf: payload.cpf,
		nome: payload.nome,
		cnpjUsuarioLogado: currentLogged
	};

	try {
		yield call(usuarioService.delUser, body);
		yield put(actions.removeUser.receive());
		const page = 0;
		yield put(actions.getUser.request(page));
	} catch (err) {}
}

export default function* root() {
	yield all([
		takeEvery(types.GET_USER.REQUEST, getUsers),
		takeEvery(types.SEARCH_USER.REQUEST, searchUser),
		takeEvery(types.LINK_USER.REQUEST, linkUser),
		takeEvery(types.REMOVE_USER.REQUEST, removeUser)
	]);
}
